export default class ProductFilter {
  constructor(node) {
    this.element = node;
    this.searchInput = this.element.querySelector(".js-search-input");
    this.products = this.element.querySelectorAll(".js-search-product");

    this.searchInput.addEventListener("input", () => {
      this.filterProducts();
    });
  }

  filterProducts() {
    this.products.forEach((product) => {
      var hasMatchingTitle = product.dataset.name.includes(this.searchInput.value.toLowerCase());
      product.classList.toggle("d-none", !hasMatchingTitle);
    });
  }
}
